import { render, staticRenderFns } from "./batch-period-record-list.vue?vue&type=template&id=241b6abd"
import script from "./batch-period-record-list.vue?vue&type=script&lang=js"
export * from "./batch-period-record-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports